import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
    selector: 'sol-loading',
    template: `
        <div id="backdrop"></div>
        <div id="holder">
            <div class="logo">
                <svg width="100%" height="100%" viewBox="0 0 118 45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Artboard</title>
                    <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="BUSINESS" transform="translate(0.000000, 35.000000)" fill="#FFFFFF" fill-rule="nonzero">
                            <path d="M0,0.571428571 L2.22218049,0.571428571 C2.5126616,0.571428571 2.80677372,0.594161959 3.10451686,0.639628733 C3.40225999,0.685095507 3.66913951,0.7795265 3.90515541,0.922921711 C4.14117131,1.06631692 4.33361505,1.26567124 4.48248662,1.52098467 C4.63135819,1.77629809 4.70579397,2.11380145 4.70579397,2.53349475 C4.70579397,2.91121872 4.58960153,3.23997848 4.35721664,3.51977401 C4.12483175,3.79956955 3.77988544,3.98493409 3.32237769,4.07586764 L3.32237769,4.0968523 C3.57654866,4.11783697 3.80893355,4.17554479 4.01953235,4.26997579 C4.23013115,4.36440678 4.41168185,4.49031477 4.56418443,4.64769976 C4.71668701,4.80508475 4.83469496,4.99219801 4.91820828,5.20903955 C5.0017216,5.42588109 5.04347826,5.66370729 5.04347826,5.92251816 C5.04347826,6.34920635 4.95814944,6.69720204 4.78749178,6.96650525 C4.61683413,7.23580845 4.40260431,7.44740382 4.14480233,7.60129136 C3.88700034,7.75517891 3.60741228,7.86010223 3.30603813,7.91606134 C3.00466397,7.97202045 2.7232604,8 2.4618274,8 L0,8 L0,0.571428571 Z M0.718940746,3.78208232 L2.21128744,3.78208232 C2.58165086,3.78208232 2.88302501,3.73836427 3.1154099,3.65092817 C3.34779479,3.56349206 3.52934548,3.45682002 3.66006198,3.33091203 C3.79077848,3.20500404 3.87792281,3.07035243 3.92149498,2.92695722 C3.96506714,2.78356201 3.98685323,2.65240786 3.98685323,2.53349475 C3.98685323,2.27468388 3.94146555,2.05959107 3.85069021,1.8882163 C3.75991486,1.71684154 3.63827589,1.58044122 3.48577331,1.47901533 C3.33327073,1.37758945 3.15535105,1.30589185 2.95201427,1.26392252 C2.7486775,1.22195319 2.53444768,1.20096852 2.30932482,1.20096852 L0.718940746,1.20096852 L0.718940746,3.78208232 Z M0.718940746,7.37046005 L2.36379003,7.37046005 C2.78498764,7.37046005 3.12448743,7.32149583 3.38228942,7.22356739 C3.6400914,7.12563896 3.83798166,7.00322841 3.97596018,6.85633575 C4.11393871,6.7094431 4.20652956,6.55380683 4.25373274,6.38942696 C4.30093593,6.22504708 4.32453752,6.0764057 4.32453752,5.94350282 C4.32453752,5.67070218 4.27007231,5.43637342 4.16114189,5.24051655 C4.05221148,5.04465967 3.91060193,4.88552596 3.73631327,4.76311542 C3.5620246,4.64070487 3.36413435,4.55152004 3.1426425,4.49556094 C2.92115066,4.43960183 2.6978433,4.41162228 2.47272044,4.41162228 L0.718940746,4.41162228 L0.718940746,7.37046005 Z" id="Shape" class="svg-elem-1"></path>
                            <path d="M21.8550725,4.815427 C21.8550725,5.23415978 21.8080116,5.63452709 21.7138898,6.01652893 C21.6197681,6.39853076 21.4622951,6.73645546 21.241471,7.03030303 C21.0206469,7.3241506 20.7310415,7.55922865 20.3726548,7.73553719 C20.0142681,7.91184573 19.5744298,8 19.0531401,8 C18.5318504,8 18.0920121,7.91184573 17.7336254,7.73553719 C17.3752387,7.55922865 17.0856333,7.3241506 16.8648092,7.03030303 C16.6439851,6.73645546 16.4865121,6.39853076 16.3923904,6.01652893 C16.2982686,5.63452709 16.2512077,5.23415978 16.2512077,4.815427 L16.2512077,0 L16.9679811,0 L16.9679811,4.62809917 C16.9679811,4.90725436 16.9933216,5.20477502 17.0440025,5.52066116 C17.0946835,5.83654729 17.1942354,6.13039486 17.3426581,6.40220386 C17.4910809,6.67401286 17.7010448,6.89807163 17.9725499,7.07438017 C18.244055,7.25068871 18.6042517,7.33884298 19.0531401,7.33884298 C19.5020285,7.33884298 19.8622252,7.25068871 20.1337303,7.07438017 C20.4052354,6.89807163 20.6151993,6.67401286 20.7636221,6.40220386 C20.9120448,6.13039486 21.0115967,5.83654729 21.0622776,5.52066116 C21.1129586,5.20477502 21.1382991,4.90725436 21.1382991,4.62809917 L21.1382991,0 L21.8550725,0 L21.8550725,4.815427 Z" id="Path" class="svg-elem-2"></path>
                            <path d="M33.7688889,6.39784946 C33.9631562,6.72043011 34.2153301,6.96057348 34.5254106,7.11827957 C34.8354911,7.27598566 35.1885346,7.35483871 35.5845411,7.35483871 C35.8311111,7.35483871 36.0627375,7.31899642 36.2794203,7.24731183 C36.4961031,7.17562724 36.6847665,7.07526882 36.8454106,6.94623656 C37.0060548,6.8172043 37.1330757,6.66129032 37.2264734,6.47849462 C37.3198712,6.29569892 37.36657,6.08960573 37.36657,5.86021505 C37.36657,5.59498208 37.3086634,5.37634409 37.1928502,5.20430108 C37.077037,5.03225806 36.9219968,4.890681 36.7277295,4.77956989 C36.5334622,4.66845878 36.3149114,4.5734767 36.0720773,4.49462366 C35.8292432,4.41577061 35.5789372,4.33691756 35.3211594,4.25806452 C35.0633816,4.17921147 34.8130757,4.08960573 34.5702415,3.98924731 C34.3274074,3.88888889 34.1088567,3.75806452 33.9145894,3.59677419 C33.7203221,3.43548387 33.5652818,3.23297491 33.4494686,2.98924731 C33.3336554,2.74551971 33.2757488,2.44444444 33.2757488,2.08602151 C33.2757488,1.74910394 33.3448631,1.44982079 33.4830918,1.18817204 C33.6213205,0.926523297 33.8081159,0.707885305 34.0434783,0.532258065 C34.2788406,0.356630824 34.549694,0.224014337 34.8560386,0.134408602 C35.1623833,0.0448028674 35.4836715,0 35.8199034,0 C36.2532689,0 36.6548792,0.0734767025 37.0247343,0.220430108 C37.3945894,0.367383513 37.7140097,0.612903226 37.9829952,0.956989247 L37.3441546,1.39784946 C37.1573591,1.14695341 36.9388084,0.958781362 36.6885024,0.833333333 C36.4381965,0.707885305 36.1411916,0.64516129 35.7974879,0.64516129 C35.5583897,0.64516129 35.3304992,0.67562724 35.1138164,0.73655914 C34.8971337,0.797491039 34.7084702,0.887096774 34.5478261,1.00537634 C34.387182,1.12365591 34.2582931,1.27240143 34.1611594,1.4516129 C34.0640258,1.63082437 34.0154589,1.84229391 34.0154589,2.08602151 C34.0154589,2.46594982 34.1163285,2.75806452 34.3180676,2.96236559 C34.5198068,3.16666667 34.7719807,3.32795699 35.0745894,3.44623656 C35.3771981,3.56451613 35.7059581,3.66845878 36.0608696,3.75806452 C36.415781,3.84767025 36.7445411,3.96774194 37.0471498,4.11827957 C37.3497585,4.2688172 37.6019324,4.47849462 37.8036715,4.74731183 C38.0054106,5.01612903 38.1062802,5.38709677 38.1062802,5.86021505 C38.1062802,6.20430108 38.0390338,6.50896057 37.9045411,6.77419355 C37.7700483,7.03942652 37.5888567,7.26344086 37.3609662,7.44623656 C37.1330757,7.62903226 36.869694,7.76702509 36.5708213,7.86021505 C36.2719485,7.95340502 35.961868,8 35.6405797,8 C35.1175523,8 34.63562,7.91218638 34.1947826,7.73655914 C33.7539452,7.5609319 33.3766184,7.26523297 33.0628019,6.84946237 L33.7688889,6.39784946 Z" id="Path" class="svg-elem-3"></path>
                            <polygon id="Path" points="49.3168116 0.571428571 49.8715942 0.571428571 49.8715942 8 49.3168116 8" class="svg-elem-4"></polygon>
                            <polygon id="Path" points="61.6425121 0.571428571 62.5397062 0.571428571 67.089008 7.07667474 67.1101185 7.07667474 67.1101185 0.571428571 67.8067633 0.571428571 67.8067633 8 66.9095692 8 62.3602674 1.49475383 62.3391569 1.49475383 62.3391569 8 61.6425121 8" class="svg-elem-5"></polygon>
                            <polygon id="Path" points="79.5748792 0.571428571 84.4386344 0.571428571 84.4386344 1.20096852 80.3162368 1.20096852 80.3162368 3.84503632 84.1802825 3.84503632 84.1802825 4.47457627 80.3162368 4.47457627 80.3162368 7.37046005 84.6183575 7.37046005 84.6183575 8 79.5748792 8" class="svg-elem-6"></polygon>
                            <path d="M95.9717874,6.39784946 C96.1660548,6.72043011 96.4182287,6.96057348 96.7283092,7.11827957 C97.0383897,7.27598566 97.3914332,7.35483871 97.7874396,7.35483871 C98.0340097,7.35483871 98.2656361,7.31899642 98.4823188,7.24731183 C98.6990016,7.17562724 98.8876651,7.07526882 99.0483092,6.94623656 C99.2089533,6.8172043 99.3359742,6.66129032 99.429372,6.47849462 C99.5227697,6.29569892 99.5694686,6.08960573 99.5694686,5.86021505 C99.5694686,5.59498208 99.511562,5.37634409 99.3957488,5.20430108 C99.2799356,5.03225806 99.1248953,4.890681 98.930628,4.77956989 C98.7363607,4.66845878 98.51781,4.5734767 98.2749758,4.49462366 C98.0321417,4.41577061 97.7818357,4.33691756 97.524058,4.25806452 C97.2662802,4.17921147 97.0159742,4.08960573 96.7731401,3.98924731 C96.530306,3.88888889 96.3117552,3.75806452 96.1174879,3.59677419 C95.9232206,3.43548387 95.7681804,3.23297491 95.6523671,2.98924731 C95.5365539,2.74551971 95.4786473,2.44444444 95.4786473,2.08602151 C95.4786473,1.74910394 95.5477617,1.44982079 95.6859903,1.18817204 C95.824219,0.926523297 96.0110145,0.707885305 96.2463768,0.532258065 C96.4817391,0.356630824 96.7525926,0.224014337 97.0589372,0.134408602 C97.3652818,0.0448028674 97.68657,0 98.0228019,0 C98.4561675,0 98.8577778,0.0734767025 99.2276329,0.220430108 C99.5974879,0.367383513 99.9169082,0.612903226 100.185894,0.956989247 L99.5470531,1.39784946 C99.3602576,1.14695341 99.1417069,0.958781362 98.891401,0.833333333 C98.641095,0.707885305 98.3440902,0.64516129 98.0003865,0.64516129 C97.7612882,0.64516129 97.5333977,0.67562724 97.316715,0.73655914 C97.1000322,0.797491039 96.9113688,0.887096774 96.7507246,1.00537634 C96.5900805,1.12365591 96.4611916,1.27240143 96.364058,1.4516129 C96.2669243,1.63082437 96.2183575,1.84229391 96.2183575,2.08602151 C96.2183575,2.46594982 96.3192271,2.75806452 96.5209662,2.96236559 C96.7227053,3.16666667 96.9748792,3.32795699 97.2774879,3.44623656 C97.5800966,3.56451613 97.9088567,3.66845878 98.2637681,3.75806452 C98.6186795,3.84767025 98.9474396,3.96774194 99.2500483,4.11827957 C99.552657,4.2688172 99.8048309,4.47849462 100.00657,4.74731183 C100.208309,5.01612903 100.309179,5.38709677 100.309179,5.86021505 C100.309179,6.20430108 100.241932,6.50896057 100.10744,6.77419355 C99.9729469,7.03942652 99.7917552,7.26344086 99.5638647,7.44623656 C99.3359742,7.62903226 99.0725926,7.76702509 98.7737198,7.86021505 C98.474847,7.95340502 98.1647665,8 97.8434783,8 C97.3204509,8 96.8385185,7.91218638 96.3976812,7.73655914 C95.9568438,7.5609319 95.5795169,7.26523297 95.2657005,6.84946237 L95.9717874,6.39784946 Z" id="Path" class="svg-elem-7"></path>
                            <path d="M111.662609,6.39784946 C111.856876,6.72043011 112.10905,6.96057348 112.41913,7.11827957 C112.729211,7.27598566 113.082254,7.35483871 113.478261,7.35483871 C113.724831,7.35483871 113.956457,7.31899642 114.17314,7.24731183 C114.389823,7.17562724 114.578486,7.07526882 114.73913,6.94623656 C114.899775,6.8172043 115.026795,6.66129032 115.120193,6.47849462 C115.213591,6.29569892 115.26029,6.08960573 115.26029,5.86021505 C115.26029,5.59498208 115.202383,5.37634409 115.08657,5.20430108 C114.970757,5.03225806 114.815717,4.890681 114.621449,4.77956989 C114.427182,4.66845878 114.208631,4.5734767 113.965797,4.49462366 C113.722963,4.41577061 113.472657,4.33691756 113.214879,4.25806452 C112.957101,4.17921147 112.706795,4.08960573 112.463961,3.98924731 C112.221127,3.88888889 112.002576,3.75806452 111.808309,3.59677419 C111.614042,3.43548387 111.459002,3.23297491 111.343188,2.98924731 C111.227375,2.74551971 111.169469,2.44444444 111.169469,2.08602151 C111.169469,1.74910394 111.238583,1.44982079 111.376812,1.18817204 C111.51504,0.926523297 111.701836,0.707885305 111.937198,0.532258065 C112.17256,0.356630824 112.443414,0.224014337 112.749758,0.134408602 C113.056103,0.0448028674 113.377391,0 113.713623,0 C114.146989,0 114.548599,0.0734767025 114.918454,0.220430108 C115.288309,0.367383513 115.607729,0.612903226 115.876715,0.956989247 L115.237874,1.39784946 C115.051079,1.14695341 114.832528,0.958781362 114.582222,0.833333333 C114.331916,0.707885305 114.034911,0.64516129 113.691208,0.64516129 C113.45211,0.64516129 113.224219,0.67562724 113.007536,0.73655914 C112.790853,0.797491039 112.60219,0.887096774 112.441546,1.00537634 C112.280902,1.12365591 112.152013,1.27240143 112.054879,1.4516129 C111.957746,1.63082437 111.909179,1.84229391 111.909179,2.08602151 C111.909179,2.46594982 112.010048,2.75806452 112.211787,2.96236559 C112.413527,3.16666667 112.6657,3.32795699 112.968309,3.44623656 C113.270918,3.56451613 113.599678,3.66845878 113.954589,3.75806452 C114.309501,3.84767025 114.638261,3.96774194 114.94087,4.11827957 C115.243478,4.2688172 115.495652,4.47849462 115.697391,4.74731183 C115.89913,5.01612903 116,5.38709677 116,5.86021505 C116,6.20430108 115.932754,6.50896057 115.798261,6.77419355 C115.663768,7.03942652 115.482576,7.26344086 115.254686,7.44623656 C115.026795,7.62903226 114.763414,7.76702509 114.464541,7.86021505 C114.165668,7.95340502 113.855588,8 113.5343,8 C113.011272,8 112.52934,7.91218638 112.088502,7.73655914 C111.647665,7.5609319 111.270338,7.26523297 110.956522,6.84946237 L111.662609,6.39784946 Z" id="Path" class="svg-elem-8"></path>
                        </g>
                        <path d="M23.7046764,2.690964 L22.8730825,3.48839786 C22.8631762,3.49792741 22.8533053,3.50752703 22.8435401,3.51723175 C22.0922182,4.26389975 21.3045148,5.01046265 20.5133918,5.75706058 C17.630998,3.61995465 13.7875595,2.75178493 10.2784297,3.60863832 L10.2752569,3.60940909 C7.62627626,4.24753836 5.0625738,6.40892361 5.97602632,9.58622159 C6.00292472,9.6797653 6.03571044,9.77152222 6.07431298,9.86093179 L6.22547984,10.211493 C6.25882962,10.2888855 6.29644506,10.3643511 6.33814991,10.4376796 C7.2929195,12.1164563 8.87911389,12.8496358 10.5683894,13.4335658 C10.5861924,13.439697 10.6040307,13.4456529 10.6219394,13.4513636 C13.2259366,14.2814152 15.9802193,14.8579527 18.5353199,15.9314982 C19.4503941,16.321544 20.3666669,16.7950433 21.1955111,17.3570763 C22.2406706,18.0899756 23.1889888,18.9960532 23.7698248,20.1505298 C23.7749013,20.1606549 23.7800484,20.17071 23.7853011,20.18073 C24.8592274,22.2390771 24.750541,24.79247 23.6766147,26.8889352 C23.6740412,26.8938752 23.6715382,26.8988502 23.6690352,26.9038252 C22.5487506,29.1304458 20.4507111,30.83662 18.1271553,31.8260812 C15.6417155,32.8848068 12.8419559,33.1232207 10.1788034,32.9474146 C6.55901287,32.6923941 2.96125578,31.6025223 0,29.5720632 L3.42536764,26.4162767 C6.29771419,28.5521915 9.89857358,29.73361 13.4575166,29.6372635 C16.7884755,29.5534245 20.3548922,27.5779355 19.7720467,23.6885491 C19.7609419,23.6146952 19.7463117,23.5414718 19.7280856,23.4690542 C19.6324782,23.0889935 19.5238271,22.8014955 19.4266685,22.598327 C18.4227908,20.4180228 16.4704187,19.4237617 14.4777871,18.7850369 C12.2667251,18.0378083 9.95550793,17.5875372 7.74451638,16.8384168 C5.90573091,16.2154577 4.08108209,15.3894702 2.78555251,13.935864 C2.76961795,13.9179611 2.75340135,13.9003034 2.73686748,13.882926 C1.48240819,12.5606313 0.854614491,10.7415039 0.848868177,8.92805224 C0.893358049,7.09350942 1.6198262,5.25991254 2.88806959,3.92314839 C2.90777628,3.90237258 2.92709517,3.88121138 2.94602629,3.85973486 C4.41126604,2.19556772 6.53084535,1.24352397 8.7078173,0.661065473 C8.71613712,0.658823227 8.72449219,0.656545946 8.73277676,0.654233629 C11.6062514,-0.148945987 14.6595892,-0.184997102 17.5779416,0.395043976 C17.582313,0.395919853 17.5866492,0.396760696 17.5910206,0.397601538 C19.7348543,0.810980657 21.8106135,1.58574681 23.7046764,2.690964 Z" id="Fill-1" stroke="#FFFFFF" stroke-width="0.5" fill="#FFFFFF" class="svg-elem-9"></path>
                        <path d="M42.3844228,1.13793103 C51.021151,1.13793103 58,8.3024225 58,17.0688941 C58,25.879874 51.021151,33 42.3844228,33 C33.7918113,33 26.7692308,25.879874 26.7692308,17.0688941 C26.7692308,8.3024225 33.7918113,1.13793103 42.3844228,1.13793103 Z M42.3844228,29.0184648 C48.8639823,29.0184648 54.0974187,23.679317 54.0974187,17.0688941 C54.0974187,10.4584712 48.8639823,5.11928761 42.3844228,5.11928761 C35.967187,5.11928761 30.671672,10.4584712 30.671672,17.0688941 C30.671672,23.679317 35.967187,29.0184648 42.3844228,29.0184648 Z" id="Fill-2" stroke="#FFFFFF" stroke-width="0.5" fill="#FFFFFF" class="svg-elem-10"></path>
                        <path d="M82.5384615,27.8647816 L82.5384615,31.862069 L59.1153846,31.862069 L59.1153846,1.13793103 L63.0431937,1.13793103 L63.0431937,25.5355301 C63.0431937,26.8219495 64.0810008,27.8647816 65.3609041,27.8647816 L82.5384615,27.8647816 Z" id="Fill-3" stroke="#FFFFFF" stroke-width="0.5" fill="#FFFFFF" class="svg-elem-11"></path>
                        <polygon id="Fill-4" fill="#FFFFFF" points="69.7115385 24.4720034 69.7115385 24.4720034 69.7115385 24.459031" class="svg-elem-12"></polygon>
                        <path d="M76.9615385,24.4588034 L71.3846154,24.4588034 C71.4340433,24.4680207 71.4834712,24.472231 71.5336654,24.472231 L76.8124884,24.472231 C76.8622995,24.472231 76.9121106,24.4680207 76.9615385,24.4588034 Z" id="Fill-5" fill="#FFFFFF" class="svg-elem-13"></path>
                        <path d="M69.7165577,18.2068966 C69.7109808,18.2482433 69.7065192,18.2897993 69.7065192,18.3315993 L69.7065192,21.495987 C69.7065192,21.5377869 69.7109808,21.579308 69.7165577,21.6206897 L69.7165577,18.2068966 Z" id="Fill-6" fill="#FFFFFF" class="svg-elem-14"></path>
                        <path d="M65.8076923,23.8188313 L65.8076923,1.13793103 L69.7070717,1.13793103 L69.7070717,19.6409035 C69.7070717,20.9689863 70.7374595,22.0455928 72.0085627,22.0455928 L82.5384615,22.0455928 L82.5384615,26.1724138 L68.0500541,26.1724138 C66.8401794,26.1014565 65.8703203,25.0846574 65.8076923,23.8188313 Z" id="Fill-7" stroke="#FFFFFF" stroke-width="0.5" fill="#FFFFFF" class="svg-elem-15"></path>
                        <path d="M100.38444,1.13793103 C109.021159,1.13793103 116,8.3024225 116,17.0688941 C116,25.879874 109.021159,33 100.38444,33 C91.7918385,33 84.7692308,25.879874 84.7692308,17.0688941 C84.7692308,8.3024225 91.7918385,1.13793103 100.38444,1.13793103 Z M100.38444,29.0184648 C106.864343,29.0184648 112.097423,23.679317 112.097423,17.0688941 C112.097423,10.4584712 106.864343,5.11928761 100.38444,5.11928761 C93.9675619,5.11928761 88.6718077,10.4584712 88.6718077,17.0688941 C88.6718077,23.679317 93.9675619,29.0184648 100.38444,29.0184648 Z" id="Fill-8" stroke="#FFFFFF" stroke-width="0.5" fill="#FFFFFF" class="svg-elem-16"></path>
                    </g>
                </svg>
                <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
            </div>
        </div>
    `,
    styles: [`
        #backdrop {
            width: 100%;
            height: 100vh;
            position: fixed;
            top: 0;
            left: 0;
            backdrop-filter: blur(3px);
            z-index: 900;
        }

        #holder {
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 901;
        }

        @-webkit-keyframes animate-svg-stroke-1 {
          0% {
            stroke-dashoffset: 48.92096710205078px;
            stroke-dasharray: 48.92096710205078px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 48.92096710205078px;
          }
        }
        
        @keyframes animate-svg-stroke-1 {
          0% {
            stroke-dashoffset: 48.92096710205078px;
            stroke-dasharray: 48.92096710205078px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 48.92096710205078px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-1 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-1 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-1 {
          -webkit-animation: animate-svg-stroke-1 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0s both,
                               animate-svg-fill-1 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1s both;
                  animation: animate-svg-stroke-1 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0s both,
                       animate-svg-fill-1 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-2 {
          0% {
            stroke-dashoffset: 39.75343704223633px;
            stroke-dasharray: 39.75343704223633px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 39.75343704223633px;
          }
        }
        
        @keyframes animate-svg-stroke-2 {
          0% {
            stroke-dashoffset: 39.75343704223633px;
            stroke-dasharray: 39.75343704223633px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 39.75343704223633px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-2 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-2 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-2 {
          -webkit-animation: animate-svg-stroke-2 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s both,
                               animate-svg-fill-2 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s both;
                  animation: animate-svg-stroke-2 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s both,
                       animate-svg-fill-2 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-3 {
          0% {
            stroke-dashoffset: 37.67054748535156px;
            stroke-dasharray: 37.67054748535156px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 37.67054748535156px;
          }
        }
        
        @keyframes animate-svg-stroke-3 {
          0% {
            stroke-dashoffset: 37.67054748535156px;
            stroke-dasharray: 37.67054748535156px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 37.67054748535156px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-3 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-3 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-3 {
          -webkit-animation: animate-svg-stroke-3 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.24s both,
                               animate-svg-fill-3 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2s both;
                  animation: animate-svg-stroke-3 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.24s both,
                       animate-svg-fill-3 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-4 {
          0% {
            stroke-dashoffset: 17.96670913696289px;
            stroke-dasharray: 17.96670913696289px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 17.96670913696289px;
          }
        }
        
        @keyframes animate-svg-stroke-4 {
          0% {
            stroke-dashoffset: 17.96670913696289px;
            stroke-dasharray: 17.96670913696289px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 17.96670913696289px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-4 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-4 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-4 {
          -webkit-animation: animate-svg-stroke-4 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.36s both,
                               animate-svg-fill-4 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3s both;
                  animation: animate-svg-stroke-4 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.36s both,
                       animate-svg-fill-4 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-5 {
          0% {
            stroke-dashoffset: 48.973846435546875px;
            stroke-dasharray: 48.973846435546875px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 48.973846435546875px;
          }
        }
        
        @keyframes animate-svg-stroke-5 {
          0% {
            stroke-dashoffset: 48.973846435546875px;
            stroke-dasharray: 48.973846435546875px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 48.973846435546875px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-5 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-5 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-5 {
          -webkit-animation: animate-svg-stroke-5 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.48s both,
                               animate-svg-fill-5 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.4s both;
                  animation: animate-svg-stroke-5 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.48s both,
                       animate-svg-fill-5 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.4s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-6 {
          0% {
            stroke-dashoffset: 42.916969299316406px;
            stroke-dasharray: 42.916969299316406px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 42.916969299316406px;
          }
        }
        
        @keyframes animate-svg-stroke-6 {
          0% {
            stroke-dashoffset: 42.916969299316406px;
            stroke-dasharray: 42.916969299316406px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 42.916969299316406px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-6 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-6 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-6 {
          -webkit-animation: animate-svg-stroke-6 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.6s both,
                               animate-svg-fill-6 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.5s both;
                  animation: animate-svg-stroke-6 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.6s both,
                       animate-svg-fill-6 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.5s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-7 {
          0% {
            stroke-dashoffset: 37.67062759399414px;
            stroke-dasharray: 37.67062759399414px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 37.67062759399414px;
          }
        }
        
        @keyframes animate-svg-stroke-7 {
          0% {
            stroke-dashoffset: 37.67062759399414px;
            stroke-dasharray: 37.67062759399414px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 37.67062759399414px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-7 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-7 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-7 {
          -webkit-animation: animate-svg-stroke-7 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.72s both,
                               animate-svg-fill-7 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.6s both;
                  animation: animate-svg-stroke-7 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.72s both,
                       animate-svg-fill-7 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.6s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-8 {
          0% {
            stroke-dashoffset: 37.6706657409668px;
            stroke-dasharray: 37.6706657409668px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 37.6706657409668px;
          }
        }
        
        @keyframes animate-svg-stroke-8 {
          0% {
            stroke-dashoffset: 37.6706657409668px;
            stroke-dasharray: 37.6706657409668px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 37.6706657409668px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-8 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-8 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-8 {
          -webkit-animation: animate-svg-stroke-8 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.84s both,
                               animate-svg-fill-8 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7000000000000002s both;
                  animation: animate-svg-stroke-8 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.84s both,
                       animate-svg-fill-8 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7000000000000002s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-9 {
          0% {
            stroke-dashoffset: 159.55577087402344px;
            stroke-dasharray: 159.55577087402344px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 159.55577087402344px;
          }
        }
        
        @keyframes animate-svg-stroke-9 {
          0% {
            stroke-dashoffset: 159.55577087402344px;
            stroke-dasharray: 159.55577087402344px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 159.55577087402344px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-9 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-9 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-9 {
          -webkit-animation: animate-svg-stroke-9 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.96s both,
                               animate-svg-fill-9 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.8s both;
                  animation: animate-svg-stroke-9 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.96s both,
                       animate-svg-fill-9 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.8s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-10 {
          0% {
            stroke-dashoffset: 175.44737243652344px;
            stroke-dasharray: 175.44737243652344px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 175.44737243652344px;
          }
        }
        
        @keyframes animate-svg-stroke-10 {
          0% {
            stroke-dashoffset: 175.44737243652344px;
            stroke-dasharray: 175.44737243652344px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 175.44737243652344px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-10 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-10 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-10 {
          -webkit-animation: animate-svg-stroke-10 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.08s both,
                               animate-svg-fill-10 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.9s both;
                  animation: animate-svg-stroke-10 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.08s both,
                       animate-svg-fill-10 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.9s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-11 {
          0% {
            stroke-dashoffset: 109.29768371582031px;
            stroke-dasharray: 109.29768371582031px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 109.29768371582031px;
          }
        }
        
        @keyframes animate-svg-stroke-11 {
          0% {
            stroke-dashoffset: 109.29768371582031px;
            stroke-dasharray: 109.29768371582031px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 109.29768371582031px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-11 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-11 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-11 {
          -webkit-animation: animate-svg-stroke-11 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2s both,
                               animate-svg-fill-11 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2s both;
                  animation: animate-svg-stroke-11 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2s both,
                       animate-svg-fill-11 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-12 {
          0% {
            stroke-dashoffset: 2.0259475708007812px;
            stroke-dasharray: 2.0259475708007812px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 2.0259475708007812px;
          }
        }
        
        @keyframes animate-svg-stroke-12 {
          0% {
            stroke-dashoffset: 2.0259475708007812px;
            stroke-dasharray: 2.0259475708007812px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 2.0259475708007812px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-12 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-12 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-12 {
          -webkit-animation: animate-svg-stroke-12 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3199999999999998s both,
                               animate-svg-fill-12 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.1s both;
                  animation: animate-svg-stroke-12 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3199999999999998s both,
                       animate-svg-fill-12 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.1s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-13 {
          0% {
            stroke-dashoffset: 13.155489921569824px;
            stroke-dasharray: 13.155489921569824px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 13.155489921569824px;
          }
        }
        
        @keyframes animate-svg-stroke-13 {
          0% {
            stroke-dashoffset: 13.155489921569824px;
            stroke-dasharray: 13.155489921569824px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 13.155489921569824px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-13 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-13 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-13 {
          -webkit-animation: animate-svg-stroke-13 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.44s both,
                               animate-svg-fill-13 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.2s both;
                  animation: animate-svg-stroke-13 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.44s both,
                       animate-svg-fill-13 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.2s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-14 {
          0% {
            stroke-dashoffset: 8.82858657836914px;
            stroke-dasharray: 8.82858657836914px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 8.82858657836914px;
          }
        }
        
        @keyframes animate-svg-stroke-14 {
          0% {
            stroke-dashoffset: 8.82858657836914px;
            stroke-dasharray: 8.82858657836914px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 8.82858657836914px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-14 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-14 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-14 {
          -webkit-animation: animate-svg-stroke-14 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.56s both,
                               animate-svg-fill-14 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.3s both;
                  animation: animate-svg-stroke-14 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.56s both,
                       animate-svg-fill-14 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.3s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-15 {
          0% {
            stroke-dashoffset: 83.48436737060547px;
            stroke-dasharray: 83.48436737060547px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 83.48436737060547px;
          }
        }
        
        @keyframes animate-svg-stroke-15 {
          0% {
            stroke-dashoffset: 83.48436737060547px;
            stroke-dasharray: 83.48436737060547px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 83.48436737060547px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-15 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-15 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-15 {
          -webkit-animation: animate-svg-stroke-15 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.68s both,
                               animate-svg-fill-15 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.4000000000000004s both;
                  animation: animate-svg-stroke-15 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.68s both,
                       animate-svg-fill-15 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.4000000000000004s both;
        }
        
        @-webkit-keyframes animate-svg-stroke-16 {
          0% {
            stroke-dashoffset: 175.4473419189453px;
            stroke-dasharray: 175.4473419189453px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 175.4473419189453px;
          }
        }
        
        @keyframes animate-svg-stroke-16 {
          0% {
            stroke-dashoffset: 175.4473419189453px;
            stroke-dasharray: 175.4473419189453px;
          }
        
          100% {
            stroke-dashoffset: 0;
            stroke-dasharray: 175.4473419189453px;
          }
        }
        
        @-webkit-keyframes animate-svg-fill-16 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        @keyframes animate-svg-fill-16 {
          0% {
            fill: transparent;
          }
        
          100% {
            fill: rgb(255, 255, 255);
          }
        }
        
        .svg-elem-16 {
          -webkit-animation: animate-svg-stroke-16 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7999999999999998s both,
                               animate-svg-fill-16 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.5s both;
                  animation: animate-svg-stroke-16 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7999999999999998s both,
                       animate-svg-fill-16 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.5s both;
        }

    `]
})

export class LoadingComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}
